'use client';

import { useEffect } from 'react';
import { useSignupNavigation } from '../hooks/useSignupNavigation';
import type { SignupStepId } from '../steps';

/**
 * Renders nothing and replaces the current step with `step`: for a step
 * reached on the wrong path, or without the answers it needs (a reload clears
 * the in-memory store).
 */
export function ReturnToStep({ step }: { step: SignupStepId }) {
  const { goToStep } = useSignupNavigation();
  useEffect(() => {
    goToStep(step);
  }, [goToStep, step]);
  return null;
}
